export class StateMachine {
    states;
    history = [];
    activeState;
    stateMachineData = {
        historyLength: 0,
        name: "sup",
    };
    stateData = {};
    constructor(states) {
        this.states = states;
        for (const state in states) {
            this.stateData[state] = {};
            const events = states[state];
            for (const eventKey in events) {
                this.stateData[state][eventKey] = {
                    nextState: events[eventKey].goTo,
                    procedures: [],
                };
            }
        }
    }
    isActiveState(state) {
        return this.activeState == state;
    }
    async triggerEvent(state, event, args) {
        if (!this.states[state]) {
            throw new Error(`The state ${String(state)} does not exist: machine- ${this.stateMachineData.name}.`);
        }
        if (!this.stateData[state][event]) {
            throw new Error(`The event ${String(event)} does not exist on the state ${String(state)}.: machine-> ${this.stateMachineData.name} data.`);
        }
        const procedures = this.stateData[state][event].procedures;
        for await (const procedure of procedures) {
            await procedure.func(args);
        }
        if (this.stateMachineData.historyLength > 0) {
            if (this.history.length > this.stateMachineData.historyLength) {
                this.history.shift();
            }
            this.history.push({
                previousState: this.activeState,
                newState: state,
                event: event,
            });
        }
        this.activeState = state;
        return this;
    }
    addToEvent(state, event, func, bind) {
        if (!this.stateData[state]) {
            throw new Error(`The state ${String(state)} does not exist: machine- ${this.stateMachineData.name}.`);
        }
        if (!this.stateData[state][event]) {
            throw new Error(`The event ${String(event)} does not exist on the state ${String(state)}.: machine-> ${this.stateMachineData.name} data.`);
        }
        this.stateData[state][event].procedures.push({
            bind: bind,
            func: func,
        });
        return this;
    }
    addToStates(data) {
        for (const state in data) {
            for (const event in data[state]) {
                this.addToEvent(state, event, data[state][event]);
            }
        }
        return this;
    }
}
